import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <ErrorStyle>
      <div className="error">
        <h2>error</h2>
        <p className="p-text">Sorry, the page you tried cannot be found</p>
        <button className="btn">
          <Link to="/" className="error__link">
            back to home
          </Link>
        </button>
      </div>
    </ErrorStyle>
  );
};

export default ErrorPage;

const ErrorStyle = styled.div`
  .error {
    height: 80vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2.5rem 0;

    &__link {
      color: #000;
    }
  }
`;
